import { render, staticRenderFns } from "./PrintReceiptBet.vue?vue&type=template&id=68b83dcb&scoped=true"
import script from "./PrintReceiptBet.vue?vue&type=script&lang=js"
export * from "./PrintReceiptBet.vue?vue&type=script&lang=js"
import style0 from "./PrintReceiptBet.vue?vue&type=style&index=0&id=68b83dcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b83dcb",
  null
  
)

export default component.exports